export const storiesData = [
  {
    image: "https://myunibest.com/stories/images/st31.png",
    video: "https://myunibest.com/stories/videos/st31.mp4",
  },
  {
    image: "https://myunibest.com/stories/images/st32.png",
    video: "https://myunibest.com/stories/videos/st32.mp4",
  },
  {
    image: "https://myunibest.com/stories/images/st33.png",
    video: "https://myunibest.com/stories/videos/st33.mp4",
  },
  {
    image: "https://myunibest.com/stories/images/st34.png",
    video: "https://myunibest.com/stories/videos/st34.mp4",
  },
  {
    image: "https://myunibest.com/stories/images/st35.png",
    video: "https://myunibest.com/stories/videos/st35.mp4",
  },
  {
    image: "https://myunibest.com/stories/images/st36.png",
    video: "https://myunibest.com/stories/videos/st36.mp4",
  },
  {
    image: "https://myunibest.com/stories/images/st37.png",
    video: "https://myunibest.com/stories/videos/st37.mp4",
  },
  {
    image: "https://myunibest.com/stories/images/st38.png",
    video: "https://myunibest.com/stories/videos/st38.mp4",
  },
  {
    image: "https://myunibest.com/stories/images/st39.png",
    video: "https://myunibest.com/stories/videos/st39.mp4",
  },
  {
    image: "https://myunibest.com/stories/images/st40.png",
    video: "https://myunibest.com/stories/videos/st40.mp4",
  },
  {
    image: "https://myunibest.com/stories/images/st41.png",
    video: "https://myunibest.com/stories/videos/st41.mp4",
  },
  {
    image: "https://myunibest.com/stories/images/st42.png",
    video: "https://myunibest.com/stories/videos/st42.mp4",
  },
  {
    image: "https://myunibest.com/stories/images/st43.png",
    video: "https://myunibest.com/stories/videos/st43.mp4",
  },
  {
    image: "https://myunibest.com/stories/images/st44.png",
    video: "https://myunibest.com/stories/videos/st44.mp4",
  },
  {
    image: "https://myunibest.com/stories/images/st45.png",
    video: "https://myunibest.com/stories/videos/st45.mp4",
  },
  {
    image: "https://myunibest.com/stories/images/st46.png",
    video: "https://myunibest.com/stories/videos/st46.mp4",
  },
  {
    image: "https://myunibest.com/stories/images/st47.png",
    video: "https://myunibest.com/stories/videos/st47.mp4",
  },
  {
    image: "https://myunibest.com/stories/images/st48.png",
    video: "https://myunibest.com/stories/videos/st48.mp4",
  },
  {
    image: "https://myunibest.com/stories/images/st49.png",
    video: "https://myunibest.com/stories/videos/st49.mp4",
  },
  {
    image: "https://myunibest.com/stories/images/st50.png",
    video: "https://myunibest.com/stories/videos/st50.mp4",
  },
  {
    image: "https://myunibest.com/stories/images/st51.png",
    video: "https://myunibest.com/stories/videos/st51.mp4",
  },
  {
    image: "https://myunibest.com/stories/images/st52.png",
    video: "https://myunibest.com/stories/videos/st52.mp4",
  },
  {
    image: "https://myunibest.com/stories/images/st53.png",
    video: "https://myunibest.com/stories/videos/st53.mp4",
  },
  {
    image: "https://myunibest.com/stories/images/st54.png",
    video: "https://myunibest.com/stories/videos/st54.mp4",
  },
  {
    image: "https://myunibest.com/stories/images/st55.png",
    video: "https://myunibest.com/stories/videos/st55.mp4",
  },
  {
    image: "https://myunibest.com/stories/images/st56.png",
    video: "https://myunibest.com/stories/videos/st56.mp4",
  },
  {
    image: "https://myunibest.com/stories/images/st57.png",
    video: "https://myunibest.com/stories/videos/st57.mp4",
  },
  {
    image: "https://myunibest.com/stories/images/st58.png",
    video: "https://myunibest.com/stories/videos/st58.mp4",
  },
  {
    image: "https://myunibest.com/stories/images/st59.png",
    video: "https://myunibest.com/stories/videos/st59.mp4",
  },
  {
    image: "https://myunibest.com/stories/images/st60.png",
    video: "https://myunibest.com/stories/videos/st60.mp4",
  },
  {
    image: "https://myunibest.com/stories/images/st61.png",
    video: "https://myunibest.com/stories/videos/st61.mp4",
  },
  {
    image: "https://myunibest.com/stories/images/st62.png",
    video: "https://myunibest.com/stories/videos/st62.mp4",
  },
  {
    image: "https://myunibest.com/stories/images/st63.png",
    video: "https://myunibest.com/stories/videos/st63.mp4",
  },
  {
    image: "https://myunibest.com/stories/images/st64.png",
    video: "https://myunibest.com/stories/videos/st64.mp4",
  },
  {
    image: "https://myunibest.com/stories/images/st65.png",
    video: "https://myunibest.com/stories/videos/st65.mp4",
  },
  {
    image: "https://myunibest.com/stories/images/st66.png",
    video: "https://myunibest.com/stories/videos/st66.mp4",
  },
  {
    image: "https://myunibest.com/stories/images/st67.png",
    video: "https://myunibest.com/stories/videos/st67.mp4",
  },
  {
    image: "https://myunibest.com/stories/images/st68.png",
    video: "https://myunibest.com/stories/videos/st68.mp4",
  },
  {
    image: "https://myunibest.com/stories/images/st69.png",
    video: "https://myunibest.com/stories/videos/st69.mp4",
  },
  {
    image: "https://myunibest.com/stories/images/st70.png",
    video: "https://myunibest.com/stories/videos/st70.mp4",
  },
  {
    image: "https://myunibest.com/stories/images/st71.png",
    video: "https://myunibest.com/stories/videos/st71.mp4",
  },
  {
    image: "https://myunibest.com/stories/images/st72.png",
    video: "https://myunibest.com/stories/videos/st72.mp4",
  },
  {
    image: "https://myunibest.com/stories/images/st73.png",
    video: "https://myunibest.com/stories/videos/st73.mp4",
  },
  {
    image: "https://myunibest.com/stories/images/st2.png",
    video: "https://myunibest.com/stories/videos/st2.mov",
  },
  {
    image: "https://myunibest.com/stories/images/st3.png",
    video: "https://myunibest.com/stories/videos/st3.mov",
  },
  {
    image: "https://myunibest.com/stories/images/st4.png",
    video: "https://myunibest.com/stories/videos/st4.mov",
  },
  {
    image: "https://myunibest.com/stories/images/st10.png",
    video: "https://myunibest.com/stories/videos/st10.mov",
  },
  {
    image: "https://myunibest.com/stories/images/st11.png",
    video: "https://myunibest.com/stories/videos/st11.mov",
  },
  {
    image: "https://myunibest.com/stories/images/st15.png",
    video: "https://myunibest.com/stories/videos/st15.mov",
  },
  {
    image: "https://myunibest.com/stories/images/st16.png",
    video: "https://myunibest.com/stories/videos/st16.mov",
  },
  {
    image: "https://myunibest.com/stories/images/st17.png",
    video: "https://myunibest.com/stories/videos/st17.mov",
  },
  {
    image: "https://myunibest.com/stories/images/st18.png",
    video: "https://myunibest.com/stories/videos/st18.mov",
  },
  {
    image: "https://myunibest.com/stories/images/st19.png",
    video: "https://myunibest.com/stories/videos/st19.mov",
  },
  {
    image: "https://myunibest.com/stories/images/st20.png",
    video: "https://myunibest.com/stories/videos/st20.mov",
  },
  {
    image: "https://myunibest.com/stories/images/st21.png",
    video: "https://myunibest.com/stories/videos/st21.mov",
  },
  {
    image: "https://myunibest.com/stories/images/st22.png",
    video: "https://myunibest.com/stories/videos/st22.mov",
  },
  {
    image: "https://myunibest.com/stories/images/st23.png",
    video: "https://myunibest.com/stories/videos/st23.mov",
  },
  {
    image: "https://myunibest.com/stories/images/st24.png",
    video: "https://myunibest.com/stories/videos/st24.mov",
  },
  {
    image: "https://myunibest.com/stories/images/st25.png",
    video: "https://myunibest.com/stories/videos/st25.mov",
  },
  {
    image: "https://myunibest.com/stories/images/st26.png",
    video: "https://myunibest.com/stories/videos/st26.mov",
  },
  {
    image: "https://myunibest.com/stories/images/st27.png",
    video: "https://myunibest.com/stories/videos/st27.mov",
  },
  {
    image: "https://myunibest.com/stories/images/st28.png",
    video: "https://myunibest.com/stories/videos/st28.mov",
  },
  {
    image: "https://myunibest.com/stories/images/st29.png",
    video: "https://myunibest.com/stories/videos/st29.mov",
  },
  {
    image: "https://myunibest.com/stories/images/st30.png",
    video: "https://myunibest.com/stories/videos/st30.mov",
  },
];
